module.exports = __webpack_public_path__ + "static/media/installerpage-icon.8eec262e.svg";